import { createFileRoute } from "@tanstack/react-router";

import { AiAgentsPage } from "@/components/marketing/ai-agents-page";
import { aiAgentsHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/ai-agents")({
  // The FAQs come from the loader, not a module-scope import, so they stay out
  // of the entry chunk (see `help.$slug`).
  loader: async () => {
    const { AI_AGENT_FAQS } = await import(
      "@/components/marketing/ai-agents-data"
    );

    return { faqs: AI_AGENT_FAQS };
  },
  head: ({ loaderData }) => (loaderData ? aiAgentsHead(loaderData.faqs) : {}),
  component: AiAgentsPage,
});
